// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"a5b3bb5f","700":"74ef72b2"}[chunkId] + ".chunk.css";
};